import { render, staticRenderFns } from "./TopMessage.vue?vue&type=template&id=fdda6336&scoped=true&"
import script from "./TopMessage.vue?vue&type=script&lang=js&"
export * from "./TopMessage.vue?vue&type=script&lang=js&"
import style0 from "./top-message.scss?vue&type=style&index=0&id=fdda6336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdda6336",
  null
  
)

export default component.exports